import sanitizeHtml from "sanitize-html";

export const stripHtmlTags = (excerpt: string): string => {
  const charLimit = 225;
  let sanitizedExcerpt = sanitizeHtml(excerpt, {
    allowedTags: [],
    allowedAttributes: {},
  });

  if (sanitizedExcerpt.length > charLimit) {
    sanitizedExcerpt = sanitizedExcerpt.substring(0, charLimit) + " ...";
  }

  return sanitizedExcerpt;
};
